import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { supportedLanguages, loadLanguage } from '../i18n';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLanguageChange = async (newLang) => {
    const currentPath = location.pathname;
    const currentLang = i18n.language;

    // Load the language if not already loaded
    await loadLanguage(newLang);

    let newPath;
    if (currentLang === 'en') {
      // Adding language prefix from English
      newPath = newLang === 'en' ? currentPath : `/${newLang}${currentPath}`;
    } else {
      // Removing or changing language prefix
      const pathWithoutLang = currentPath.replace(`/${currentLang}`, '') || '/';
      newPath = newLang === 'en' ? pathWithoutLang : `/${newLang}${pathWithoutLang}`;
    }

    i18n.changeLanguage(newLang);
    navigate(newPath);
  };

  return (
    <div className="relative inline-flex items-center">
      <Globe size={16} className="absolute left-2 text-gray-500 pointer-events-none" />
      <select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="pl-7 pr-2 py-1.5 border border-gray-300 rounded-lg bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7c9b] focus:border-transparent cursor-pointer appearance-none"
        style={{ minWidth: '120px' }}
      >
        {supportedLanguages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.nativeName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
